import { useQuery } from "react-query";

import axios from "axios";
import { PAD_SCENARIO_SERVICE_ADDRESS } from "constants/app.constants";

import { ProjectModel, projectServiceEndpoint } from "api/project";

import { Scenario } from "components/pad-generator/models/scenario";

const API_URL = `${PAD_SCENARIO_SERVICE_ADDRESS}/api/v1/pad-scenario`;

export interface OrgScenario extends Scenario {
  projectName: string;
  projectId: string;
}

async function fetchAllOrgScenarios(): Promise<OrgScenario[]> {
  const projectsResponse = await axios.get<ProjectModel[]>(
    `${projectServiceEndpoint}/projects`
  );
  const projects = projectsResponse.data ?? [];

  const results = await Promise.all(
    projects.map(async (project) => {
      try {
        const response = await axios.get<Scenario[]>(`${API_URL}/${project.projectId}`);
        return (response.data ?? []).map((scenario) => ({
          ...scenario,
          projectName: project.projectName,
          projectId: project.projectId
        }));
      } catch {
        return [];
      }
    })
  );

  return results.flat();
}

export function useOrgScenarios(enabled = true) {
  return useQuery<OrgScenario[]>("orgScenarios", fetchAllOrgScenarios, {
    enabled,
    refetchOnWindowFocus: false
  });
}
